<template>
  <v-tooltip bottom :disabled="!help">
    <v-btn
      slot="activator"
      class="soraban-button my-0"
      :id="id"
      @click="$emit('click')"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
      fab
      small
      flat
      :disabled="disabled"
    >
      <i
        :class="
          filled
            ? 'material-icons primary--text'
            : `material-icons-outlined ${color}--text`
        "
      >
        {{ icon }}
      </i>
    </v-btn>
    <span
      >{{ help
      }}<span v-if="shortcut"
        ><div class="shortcut-key">u</div>
        Shortcut</span
      ></span
    >
  </v-tooltip>
</template>

<script>
export default {
  name: 'SorabanActionButton',
  props: {
    id: {
      type: String,
    },
    shortcut: {
      required: false,
      type: String,
    },
    color: {
      required: false,
      default: 'darkgrey',
      type: String,
      validator: p => ['primary', 'darkgrey', 'error'].includes(p),
    },
    help: {
      required: false,
      type: String,
    },
    icon: {
      required: true,
      type: String,
    },
    disabled: {
      required: false,
      type: Boolean,
    },
    size: {
      required: false,
      type: String,
      default: '',
      validator: p => ['', 'small', 'large'].includes(p),
    },
    block: {
      required: false,
      default: false,
      type: Boolean,
    },
    variation: {
      required: false,
      type: String,
      default: '',
      validator: p =>
        ['', 'clear', 'icon', 'outline', 'pill', 'fab'].includes(p),
    },
    filled: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
};
</script>

<style>
.soraban-button.v-btn {
  margin: 0 8px 8px;
}
</style>

<style scoped lang="postcss">
.soraban-button {
  font-weight: 600;
  text-transform: none;
  font-size: var(--type-interface);

  &.v-btn--small {
    font-size: calc(var(--type-interface) - 1px);
  }
  &.v-btn--large {
    font-size: calc(var(--type-interface) + 1px);
  }

  &:not(.v-btn--round):not(.v-btn--icon) {
    border-radius: 3px;
    &:before {
      border-radius: 0;
    }
  }

  &.grey {
    /* Vuetify override to make the text white because our grey buttons are darker than vuetify expects  */
    color: var(--color-white);
  }

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.6;
    font-style: italic;
    &:not(.v-btn--icon) {
      background-color: var(--color-grey) !important;
    }
  }

  &:not(.v-btn--small):not(.v-btn--large) {
    min-height: var(--button-height--default);
  }

  /*
    Vuetify overrides
  */
  &:hover:before,
  &:focus:before {
    /* Darken hover rather than lighten */
    background-color: var(--color-black);
  }

  &.v-btn--flat:hover:before,
  &.v-btn--flat:focus:before {
    background-color: currentColor;
  }

  &.v-btn--outline:hover >>> .v-btn__content,
  &.v-btn--outline:focus >>> .v-btn__content {
    color: var(--color-white);
  }
  &.v-btn--outline:hover:before,
  &.v-btn--outline:focus:before {
    background-color: currentColor;
    opacity: 8;
  }

  &:not(&--depressed):not(&--flat) {
    box-shadow: var(--box-shadow--default);
  }
}
</style>
